module.exports = __webpack_public_path__ + "img/merlin.8b5685d9.png";